import { t as body_lock_default } from "./body-lock-CZ1CTkMb.js";
import { r as handleSortInteraction } from "./filter-DERodJ0X.js";
//#region src/scripts/extenders/filter-handler.js
var FilterHandler = class extends HTMLElement {
	constructor() {
		super();
		this.openDrawer = (event) => {
			event.preventDefault();
			this.drawer.classList.add("open");
			this.curtain.classList.add("open");
			body_lock_default.lock();
		};
		this.closeDrawer = () => {
			this.drawer.classList.remove("open");
			this.curtain.classList.remove("open");
			body_lock_default.unlock();
		};
		this.handleSortChange = (event) => {
			const selectedOption = event.target.options[event.target.selectedIndex];
			if (this.sortLabel && selectedOption?.dataset.label) this.sortLabel.textContent = selectedOption.dataset.label;
			handleSortInteraction(event.target.value);
		};
		this.handleDocumentKeyDown = (event) => {
			if (event.key === "Tab") this.isKeyboardNavigation = true;
		};
		this.handleDocumentPointerDown = () => {
			this.isKeyboardNavigation = false;
		};
		this.handleSortFocus = () => {
			if (this.isKeyboardNavigation) this.sortButton?.classList.add("collection-toolbar__sort-label--focus-visible");
		};
		this.handleSortBlur = () => {
			this.sortButton?.classList.remove("collection-toolbar__sort-label--focus-visible");
		};
	}
	connectedCallback() {
		this.toggleFilterDrawer = this.querySelector(".js-toggle-drawer");
		this.sortBy = this.querySelector(".js-sort-by");
		this.sortLabel = this.querySelector(".js-sort-label");
		this.sortButton = this.querySelector(".collection-toolbar__sort-label");
		this.drawer = this.querySelector(".filter-drawer");
		this.curtain = this.querySelector(".curtain");
		this.close = this.querySelector(".filter-head button");
		this.loading = this.querySelector(".loading");
		this.apply = this.querySelector(".js-apply");
		this.toggleFilterDrawer?.addEventListener("click", this.openDrawer);
		this.sortBy?.addEventListener("change", this.handleSortChange);
		this.sortBy?.addEventListener("focus", this.handleSortFocus);
		this.sortBy?.addEventListener("blur", this.handleSortBlur);
		document.addEventListener("keydown", this.handleDocumentKeyDown);
		document.addEventListener("pointerdown", this.handleDocumentPointerDown);
		this.close?.addEventListener("click", this.closeDrawer);
		this.loading?.addEventListener("click", this.closeDrawer);
		this.apply?.addEventListener("click", this.closeDrawer);
	}
	disconnectedCallback() {
		this.toggleFilterDrawer?.removeEventListener("click", this.openDrawer);
		this.sortBy?.removeEventListener("change", this.handleSortChange);
		this.sortBy?.removeEventListener("focus", this.handleSortFocus);
		this.sortBy?.removeEventListener("blur", this.handleSortBlur);
		document.removeEventListener("keydown", this.handleDocumentKeyDown);
		document.removeEventListener("pointerdown", this.handleDocumentPointerDown);
		this.close?.removeEventListener("click", this.closeDrawer);
		this.loading?.removeEventListener("click", this.closeDrawer);
		this.apply?.removeEventListener("click", this.closeDrawer);
	}
};
if (customElements.get("filter-handler") === void 0) customElements.define("filter-handler", FilterHandler);
//#endregion
